module.exports = __webpack_public_path__ + "img/magnus-logo.f595bb95.svg";